export const DESCRIPTION = 'description';
export const COMPLETED = 'completed';
export const USER_ID = 'user_id';
export const REVIEWER_ID = 'reviewer_id';
export const TITLE = 'title';
export const TEXT = 'comments';
export const USER_ACTION_LIST = 'user_action_items';
export const REVIEWER_ACTION_LIST = 'reviewer_action_items';
export const USER_ACTION_LIST_ATT = 'user_action_items_attributes';
export const REVIEWER_ACTION_LIST_ATT = 'reviewer_action_items_attributes';
export const USER_NAME = 'name';
export const CREATED_AT = 'created_at';
export const UPDATED_AT = 'updated_at';
